import Enumerable from "linq";
import { Point } from "../../../domain/drawing";

export class SvgPathFactory {
  public static createPolyline(...points: Point[]): string {
    return Enumerable.from(points)
      .select((p, i) => this.toPolylinePath(p, i))
      .toArray()
      .join(" ");
  }

  public static createWaveLine(from: Point, to: Point, r: number): string {
    const x = to.x - from.x;
    const y = to.y - from.y;
    const middlePoint = new Point(from.x + x / 2, from.y + y / 2);
    const shortPoint = new Point(from.x + x / 4, from.y + y / 4);
    const angle = this.calculateAngle(x, y) + Math.PI / 2;
    const curvePoint = new Point(shortPoint.x + Math.cos(angle) * r, shortPoint.y + Math.sin(angle) * r);
    const startPath = this.toMovePath(from);
    const curvePath = this.toCurveLinePath(curvePoint);
    const middlePath = this.toPathString(middlePoint);
    const endPath = this.toMirrorPath(to);
    return startPath + " " + curvePath + " " + middlePath + " " + endPath;
  }

  private static calculateAngle(x: number, y: number): number {
    if (x === 0) {
      if (y > 0) { return Math.PI / 2; }
      if (y < 0) { return Math.PI / 2 * -1; }
      return 0;
    }
    return Math.atan(y / x);
  }

  private static toPolylinePath(location: Point, index: number): string {
    return (index === 0)
      ? this.toMovePath(location)
      : this.toLinePath(location);
  }

  public static createHorizontalLine(from: Point, length: number): string {
    return this.toMovePath(from) + " " + this.toHorizontalPath(length);
  }

  public static createVerticalLine(from: Point, length: number): string {
    return this.toMovePath(from) + " " + this.toVerticalPath(length);
  }

  private static toMovePath(location: Point): string {
    return "M " + this.toPathString(location);
  }

  private static toLinePath(location: Point): string {
    return "L " + this.toPathString(location);
  }

  private static toCurveLinePath(location: Point): string {
    return "Q " + this.toPathString(location);
  }

  private static toMirrorPath(location: Point): string {
    return "T " + this.toPathString(location);
  }

  private static toPathString(location: Point): string {
    return Math.round(location.x) + "," + Math.round(location.y);
  }

  private static toHorizontalPath(length: number): string {
    return "H " + this.toLengthString(length);
  }

  private static toVerticalPath(length: number): string {
    return "V " + this.toLengthString(length);
  }

  private static toLengthString(length: number): string {
    return Math.round(length).toString();
  }
}
